import Cookies from 'js-cookie';

const cookieOptions = {
    secure: process.env.REACT_APP_NODE_ENV !== 'DEV',  // enable secure cookies in production
    sameSite: 'strict',
};

if (process.env.REACT_APP_NODE_ENV !== 'DEV') {
    cookieOptions.domain = process.env.REACT_APP_DOMAIN || '.voiceproconnect.com';
}

const jwtCookieManager = {
    getToken: () => Cookies.get(process.env.REACT_APP_TOKEN_NAME_KEY),
    setToken: (token) => {
        console.log('Setting cookie with options:', cookieOptions);
        Cookies.set(process.env.REACT_APP_TOKEN_NAME_KEY, token, cookieOptions);
        return true;
    },
    eraseToken: () => {
        Cookies.remove(process.env.REACT_APP_TOKEN_NAME_KEY, { domain: cookieOptions.domain });
        return true;
    },
};

export default jwtCookieManager;
